import React from 'react';
import {useDispatch} from "react-redux";
import {useForm} from "react-hook-form";
import {useMediaQuery} from "@react-hook/media-query";

import Input from "../../core/Input";
import {assetsBaseUrl} from "../../../services/calculationsApi";
import {calculateYearlyIncomeIndependentAction} from "../../../store/actions/calculatorActions";
import {mainMediaMobile} from "../../../services/helpers";
import {gtm} from "../../../services/gtm";
import {FormattedMessage, useIntl} from "react-intl";

const LastStepOfBusinessCalculator = ({toggleIncomeCalculator, field, toggleLastStep}) => {
  const intl = useIntl();
  const fields = ['ld', 'lvu', 'ov', 'sfw', 'bpga'];
  const currentYear = new Date().getFullYear();
  const years = [
    currentYear - 1,
    currentYear - 2,
    currentYear - 3,
  ];
  const labels = [
    intl.formatMessage({ id: 'incomeCalculator.type.selfEmployed.lastStep.incomeLabels.saldoFiscaleWinst', defaultMessage: 'Saldo fiscale winst' }),
    intl.formatMessage({ id: 'incomeCalculator.type.selfEmployed.lastStep.incomeLabels.loonvervangendeUitkeringen', defaultMessage: 'Loonvervangende uitkeringen' }),
    intl.formatMessage({ id: 'incomeCalculator.type.selfEmployed.lastStep.incomeLabels.ontslagvergoeding', defaultMessage: 'Ontslagvergoeding' }),
    intl.formatMessage({ id: 'incomeCalculator.type.selfEmployed.lastStep.incomeLabels.loondienst', defaultMessage: 'Loondienst' }),
    intl.formatMessage({ id: 'incomeCalculator.type.selfEmployed.lastStep.incomeLabels.bijtellingPriveGebruikAuto', defaultMessage: 'Bijtelling prive gebruik auto' }),
  ];

    const mediaMatches = useMediaQuery(mainMediaMobile);
    const {register, handleSubmit} = useForm({
        mode: 'onChange',
    });
    const dispatch = useDispatch();

    const onSubmit = data => {
        dispatch(calculateYearlyIncomeIndependentAction(data, field));

        const tagManagerArgs = {
            gtmId: 'GTM-T78CX5',
            dataLayer: {
                event: "gtm.trackEvent",
                eventCategory: "Jaarinkomen berekenen",
                eventAction: "Berekening uitvoeren",
                eventLabel: "Zelfstandige"
            }
        };

        gtm(tagManagerArgs);
        //TagManager.initialize(tagManagerArgs);

        toggleIncomeCalculator();
    };

    return (
        <div>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className="ct-step__overview-modal-title">
                  <FormattedMessage id="incomeCalculator.type.selfEmployed.lastStep.title" defaultMessage="Benodigde gegevens"/>
                </div>

                <div className="close-income" onClick={toggleIncomeCalculator}>
                    <img src={`${assetsBaseUrl}/assets/svg/close.svg`} alt=""/>
                </div>

                <div className="ct__last-step-back" onClick={toggleLastStep}>
                    <img src={`${assetsBaseUrl}/assets/svg/arrow-down-secondary.svg`} alt=""/>
                    <FormattedMessage id="incomeCalculator.type.selfEmployed.lastStep.previous" defaultMessage="Vorige stap"/>
                </div>

                <div className="ct-step__income-calculator-modal__subtitle last-step-subtitle">
                  <FormattedMessage id="incomeCalculator.type.selfEmployed.lastStep.subTitle" defaultMessage="Heb je aangiftes inkomstenbelasting en je jaarcijfers bij de hand? Vul de gegevens in die van toepassing zijn. Dit kan betekenen dat je niet alles hoeft in te vullen."/>
                </div>
                <div>
                    <div className="ct__last-step-years">
                        {years.map((item) => {
                            return (
                                <div key={item}>
                                    {item}
                                </div>
                            )
                        })}
                    </div>

                    <div className="ct__last-step-fields-labels">

                        {fields.map((fieldName, fieldNameIndex) => {
                            const inputs = [1, 2, 3].map((number, numberIndex) => {
                                const name = fieldName + number;

                                return (
                                    <Input
                                        inputType="secondary"
                                        placeholder="2200"
                                        type="number"
                                        register={register}
                                        name={name}
                                        valueType={(fieldNameIndex === 2 || fieldNameIndex === 4) ? "-" : null}
                                        label={mediaMatches ? years[numberIndex] : null}
                                        key={fieldName + number}
                                    />
                                )
                            });

                            return (
                                <div key={fieldName}>
                                    <div>
                                        {labels[fieldNameIndex]}
                                    </div>

                                    <div className="ct__last-step-fields">
                                        {inputs}
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                </div>


                <button
                    type="submit"
                    className="ct__button ct-header__afspraak"
                >
                  <FormattedMessage id="incomeCalculator.calculateOnButton" defaultMessage="Reken verder"/>
                </button>
            </form>
        </div>
    );
};

export default LastStepOfBusinessCalculator;
